import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PnsMacMiniUser } from 'interfaces/pns-mac-mini-user'

interface MacMiniUserResponse {
  data: PnsMacMiniUser[]
  total: number
}

const fetchMacMiniUserByUsername = async (
  username: string
): Promise<PnsMacMiniUser | null> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_mini_users?usernameSearch=${encodeURIComponent(
      username
    )}&limit=1`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)

  const data: MacMiniUserResponse = await response.json()

  // Return the first matching user, or null if not found
  return data.data.length > 0 ? data.data[0] : null
}

const useMacMiniUserByPhone = (phoneName: string) => {
  return useQuery(
    ['mac-mini-user-by-phone', phoneName],
    () => fetchMacMiniUserByUsername(phoneName),
    {
      enabled: !!phoneName, // Only fetch if phoneName is provided
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 2,
    }
  )
}

export default useMacMiniUserByPhone
